import React from "react";
import CustomCard from "../../shared/Card/CustomCard";
import ContactForm from "./ContactForm";

export default function ViewContact({ name }) {
    return (
        <CustomCard title={name}>
            <ContactForm type="VIEW" />
        </CustomCard>
    );
}
